import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import './Loader.scss'

const Loader = () => {
    return <div className='Loader'><CircularProgress/>
    </div>
}

export default Loader